import React, {FC, ReactNode} from 'react';

interface TabPanelProps {
    children?: ReactNode;
    index: any;
    value: any;
}

const TabPanel: FC<TabPanelProps> = ({children, value, index}: TabPanelProps) =>
    value === index ? <>{children}</> : null;

export default TabPanel;
